
import { defineComponent } from '@vue/runtime-core';
import { ClientConstants } from './../client.constants';
import FdicModal from './FdicModal.vue';

export default defineComponent({
  name: 'AmountModal',
  components: { FdicModal },
  props: {
    amountValue: { type: String, default: '' },
    amountInvalid: { type: Boolean, default: false },
    amountMaxExceeded: { type: Boolean, default: false }
  },
  data: function () {
    return {
      clientConstants: ClientConstants
    };
  },
  methods: {
    openModal() {
      (this.$refs.fdicModal as typeof FdicModal).openFdicModal();
    },
    amountChanged(event: Event): void {
      this.$emit('amountChanged', (event.target as HTMLInputElement).value);
    },
    nextButtonClicked() {
      // If the input field is unchanged when the next button is clicked, we need to
      // emit the amountChanged event to force validation in the parent component.
      const amountNeverEntered = this.amountValue.trim() === '';
      if (amountNeverEntered) {
        this.$emit('amountChanged', '');
      } else if (!amountNeverEntered && !this.amountInvalid && !this.amountMaxExceeded) {
        this.$emit('closeAmountModal');
      }
    },
    clearAmount() {
      (document.querySelector('.pvd-input__input') as HTMLInputElement).value = '';
    }
  }
});
